window.$ = window.jQuery = require('jquery');
window.Cookies = require('js-cookie');

import angular from 'angular';

require('angular-cookies');
require('bootstrap-sass');
require('./globals');

var myApp = angular.module('myApp', [
    require('ng-admin'),
    require('angular-material'),
    require('angular-messages'),
    require('angular-material-data-table'),
    require('./constants'),
    require('./services'),
    require('./controllers'),
    require('./directives'),
    require('./run'),
    require('./router'),
    require('./filters')
]);

myApp.config(['RestangularProvider', require('./config/request_interceptor')]);
myApp.config(['RestangularProvider', require('./config/response_interceptor')]);
myApp.config(['$provide', require('./config/overwrite_directives')]);
myApp.config(['RestangularProvider', '$windowProvider', require('./config/error_interceptor')]);
myApp.config(['$mdThemingProvider', require('./config/material_interceptor')]);
myApp.config(['$translateProvider', require('./languages/languages')]);
myApp.config(['$translateProvider', require('./languages/languages')]);
myApp.config(['$mdDateLocaleProvider', require('./config/datepiker.js')]);

myApp.config(['NgAdminConfigurationProvider', 'Api', function (nga, Api) {

    // create the admin application
    var admin = nga.application('BrainVT')
        .baseApiUrl(Api.Path);


    admin.addEntity(nga.entity('game'));
    admin.addEntity(nga.entity('gamevr'));
    admin.addEntity(nga.entity('user'));
    admin.addEntity(nga.entity('prenscriptor'));
    admin.addEntity(nga.entity('prescriberType'));
    admin.addEntity(nga.entity('variable'));
    admin.addEntity(nga.entity('config'));
    admin.addEntity(nga.entity('ability'));
    admin.addEntity(nga.entity('licence'));
    admin.addEntity(nga.entity('gamevrlicence'));
    admin.addEntity(nga.entity('subscription'));
    admin.addEntity(nga.entity('purchase'));
    admin.addEntity(nga.entity('product'));
    admin.addEntity(nga.entity('event'));
    admin.addEntity(nga.entity('interested'));
    admin.addEntity(nga.entity('invoice'));
    admin.addEntity(nga.entity('payment'));
    admin.addEntity(nga.entity('promo'));
    admin.addEntity(nga.entity('competence'));
    admin.addEntity(nga.entity('licencetype'));
    admin.addEntity(nga.entity('company'));
    admin.addEntity(nga.entity('professional'));

    require('./entities/game/config')(nga, admin);
    require('./entities/gamevr/config')(nga, admin);
    require('./entities/user/config')(nga, admin);
    require('./entities/prenscriptor/config')(nga, admin);
    require('./entities/company/config')(nga, admin);
    require('./entities/prescribertype/config')(nga, admin);
    require('./entities/variable/config')(nga, admin);
    require('./entities/config/config')(nga, admin);
    require('./entities/ability/config')(nga, admin);
    require('./entities/licence/config')(nga, admin);
    require('./entities/gamevrlicence/config')(nga, admin);
    require('./entities/subscription/config')(nga, admin);
    require('./entities/purchase/config')(nga, admin);
    require('./entities/product/config')(nga, admin, Api);
    require('./entities/event/config')(nga, admin, Api);
    require('./entities/interested/config')(nga, admin);
    require('./entities/invoice/config')(nga, admin);
    require('./entities/payment/config')(nga, admin);
    require('./entities/promo/config')(nga, admin);
    require('./entities/competence/config')(nga, admin);
    require('./entities/licencetype/config')(nga, admin);

    admin.menu(require('./menu')(nga, admin));
    //admin.dashboard(require('./theme/dashboard/config')(nga, admin));
    admin.header(require('./theme/header/view.html'));
    admin.layout(require('./theme/main/view.html'));


    // attach the admin application to the DOM and execute it
    nga.configure(admin);
}]);


myApp.config(['$compileProvider', function($compileProvider) {
    $compileProvider.preAssignBindingsEnabled(true);
}]);

myApp.config(['$qProvider', function ($qProvider) {
    $qProvider.errorOnUnhandledRejections(false);
}]);



/** WEBPACK FOOTER **
 ** ./js/main.js
 **/